import { render, staticRenderFns } from "./CollectionFilterControlTypeDateTimeLocal.vue?vue&type=template&id=61c8c3f0"
import script from "./CollectionFilterControlTypeDateTimeLocal.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeDateTimeLocal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports